// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3s1Gu","name":"ConsentHeader_name__yZ0Yn","birthday":"ConsentHeader_birthday__1kxKO","skeleton":"ConsentHeader_skeleton__2KwSY"};